var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'vcheckbox_label',
    { disabled: _vm.disabled },
    { clickable: _vm.isLabelClickable },
    { custom_online: _vm.custom_online }
  ]},[_c('div',{staticClass:"checkbox-wrap checkbox_label_content",on:{"click":_vm.change}},[_c('vfocus-field',{attrs:{"type":"checkbox","disabled":_vm.disabled}},[_c('vcheckbox',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltip),expression:"tooltip"}],attrs:{"value":_vm.value,"disabled":_vm.disabled}})],1)],1),_vm._v(" "),_c('div',{staticClass:"checkbox_label",class:{ 'checkbox_label--mini': _vm.mini },domProps:{"innerHTML":_vm._s(_vm.label)},on:{"click":_vm.changeLabel}})])
}
var staticRenderFns = []

export { render, staticRenderFns }